const aboutNewSliderHandler = () => {
  const Slider = document.getElementsByClassName('about-new__cluster-slider ');

  if (!Slider.length) return;

  $(Slider).slick({
    fade: true,
    slidesToShow: 1,
    prevArrow:
      "<button class='slick-arrow slick-prev'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-round'></use></svg></button>",
    nextArrow:
      "<button class='slick-arrow slick-next'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-round'></use></svg></button>",
    responsive: [
      {
        breakpoint: 1281,
        settings: {
          prevArrow:
            "<button class='slick-arrow slick-prev'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-bigger'></use></svg></button>",
          nextArrow:
            "<button class='slick-arrow slick-next'><svg><use xlink:href='/static/core/img/sprites.svg#arrow-left-bigger'></use></svg></button>"
        }
      }
    ]
  });
};

const AboutNewComponent = () => {
  aboutNewSliderHandler();
};

export const AboutNew = () => {
  $(document).ready(() => AboutNewComponent());
};
